module.exports = __webpack_public_path__ + "static/media/teamwork.2b7f5f60.svg";